import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { ContextService } from '../../../services'

@Component({
  standalone: false,
  selector: 'app-map-controls',
  templateUrl: './map-controls.component.html',
  styleUrls: ['./map-controls.component.scss'],
})
export class MapControlsComponent implements OnInit {
  @Input() map: any

  @Input() basemapList: any[] = []
  basemapSelectorOpen = false

  get currentBasemap() {
    return this.context && this.context.currentBasemap
  }

  set currentBasemap(val) {
    this.context.currentBasemap = val
  }

  @Output() basemapChanged = new EventEmitter<string>()

  constructor(private context: ContextService) {}

  ngOnInit() {
    if (!this.currentBasemap) {
      this.basemapList.forEach((elem) => {
        elem.active = false
      })
      this.currentBasemap = this.basemapList[0]
      this.currentBasemap.active = true
    }
  }

  changeBasemap(item) {
    if (!item.active) {
      this.basemapList.forEach((elem) => {
        elem.active = false
      })
      this.currentBasemap = item
      item.active = true
      // Close panel after a moment
      setTimeout(() => {
        this.basemapSelectorOpen = false
      }, 500)
      this.basemapChanged.emit(this.currentBasemap)
    }
  }

  zoomIncrease() {
    this.map.zoomIn()
  }

  zoomDecrease() {
    this.map.zoomOut()
  }

  toggleBasemapSelector() {
    this.basemapSelectorOpen = !this.basemapSelectorOpen
  }
}
